import { icons } from '@/config/version-manage/data/icon-editor';
import { PropertyEditor } from '@/@types/version-manage';
import { ComponentPropertyEditor } from '@/@types/version-manage/enum';
import { FormEditor } from '@/@types/version-manage/form';

/** 属性编辑器 */
const propertyEditors: Array<FormEditor> = [
  {
    name: 'any',
    description: '任意',
    component: 'text-editor',
    attrs: {
      style: { width: '100%' },
      allowClear: true,
      size: 'small',
    },
    editor: ComponentPropertyEditor.any,
  },
  {
    name: 'width',
    description: '长度',
    component: 'width-editor',
    formatter: val => `${val}px`,
    editor: ComponentPropertyEditor.width,
  },
  {
    name: 'color',
    description: '颜色',
    component: 'color-picker',
    attrs: {
      style: { width: '100%' },
      allowClear: true,
      addonAfter: '颜色',
      size: 'small',
      showAlpha: false,
      colorType: 'hex',
      canChangeColorType: false,
      canClear: false,
    },
    editor: ComponentPropertyEditor.color,
  },
  {
    name: 'single-line',
    description: '单行文本',
    component: 'text-editor',
    attrs: {
      style: { width: '100%' },
      allowClear: false,
      size: 'small',
    },
    editor: ComponentPropertyEditor.singerLine,
  },
  {
    name: 'date-picker',
    description: '日期选择',
    component: 'date-picker',
    attrs: {
      style: { width: '100%' },
      allowClear: false,
      size: 'small',
    },
    editor: ComponentPropertyEditor.date,
  },
  {
    name: 'date-range-picker',
    description: '日期区间选择',
    component: 'date-range-picker',
    attrs: {
      style: { width: '100%' },
      allowClear: false,
      size: 'small',
    },
    editor: ComponentPropertyEditor.daterange,
  },
  {
    name: 'multi-line',
    description: '多行文本',
    component: 'a-textarea',
    attrs: {
      style: { width: '100%' },
      allowClear: true,
      size: 'small',
      autoSize: { minRows: 2, maxRows: 6 },
    },
    editor: ComponentPropertyEditor.multiLine,
  },
  {
    name: 'boolean',
    description: '真假',
    component: 'switch-editor',
    attrs: {
      checkedChildren: '是',
      unCheckedChildren: '否',
    },
    editor: ComponentPropertyEditor.boolean,
  },
  {
    name: 'int',
    description: '整数',
    component: 'a-input-number',
    attrs: {
      precision: 0,
      min: 0,
      style: { width: '100%' },
      allowClear: true,
      size: 'small',
    },
    editor: ComponentPropertyEditor.int,
  },
  {
    name: 'float',
    description: '小数',
    component: 'a-input-number',
    attrs: {
      step: 0.1,
      min: 0,
      style: { width: '100%' },
      allowClear: true,
      size: 'small',
    },
    editor: ComponentPropertyEditor.float,
  },
  {
    name: 'list',
    description: '列表',
    component: 'a-select',
    attrs: {
      allowClear: false,
      buttonStyle: 'solid',
      style: { width: '100%' },
      size: 'small',
    },
    editor: ComponentPropertyEditor.list,
  },
  {
    name: 'icon',
    description: '图标',
    component: 'a-select',
    events: {},
    attrs: {
      showSearch: true,
      style: {
        width: '100%',
        fontFamily: 'vant-icon',
        color: 'rgba(0, 0, 0, 0.65)',
        fontSize: '20px',
        lineHeight: '12px',
        // fontWeight: '700',
        verticalAlign: 'middle',
      },
      dropdownClassName: 'icon-editor-select',
      placeholder: '',
      allowClear: true,
      size: 'small',
    },
    slot: {
      default: icons.map(i => ({
        component: 'a-select-option',
        html: i.label,
        slot: {
          default: icons,
        },
        attrs: {
          value: i.value,
        },
      })),
    },
    editor: ComponentPropertyEditor.icon,
  },
  {
    name: 'json',
    description: 'JSON',
    component: 'object-editor',
    slot: {},
    attrs: {
      isExpression: true,
      language: 'javascript',
      options: {
        lineNumbers: 'off',
        scrollBeyondLastLine: false,
      },
      style: { width: '100%', height: '300px' },
    },
    editor: ComponentPropertyEditor.json,
  },
  {
    name: 'model-list',
    description: '对象列表',
    component: 'model-list-editor',
    editor: ComponentPropertyEditor.modelList,
  },
  {
    name: 'expression',
    description: '表达式',
    component: 'code-editor',
    slot: {},
    attrs: {
      isExpression: true,
      language: 'javascript',
      options: {
        lineNumbers: 'off',
        scrollBeyondLastLine: false,
      },
      style: { width: '100%', height: '80px' },
    },
    editor: ComponentPropertyEditor.expression,
  },
  {
    name: 'variable',
    description: '变量',
    component: 'variable-picker',
    slot: {},
    attrs: {
      style: { width: '100%' },
      allowClear: true,
      size: 'small',
    },
    editor: ComponentPropertyEditor.variable,
  },
  {
    name: 'function',
    description: '函数',
    component: 'function-picker',
    slot: {},
    attrs: {
      style: { width: '100%' },
      allowClear: true,
      size: 'small',
    },
    editor: ComponentPropertyEditor.function,
  },
  {
    name: 'rules',
    description: '校验规则',
    component: 'rules-editor',
    editor: ComponentPropertyEditor.rules,
  },
  {
    name: 'box',
    description: '盒模型编辑器',
    component: 'box-editor',
    editor: ComponentPropertyEditor.box,
  },
  {
    name: 'richtext',
    description: '富文本编辑器',
    component: 'rich-text-editor',
    editor: ComponentPropertyEditor.richtext,
  },
  {
    name: 'component',
    description: '组件',
    component: 'component-picker',
    slot: {},
    attrs: {
      style: { width: '100%' },
      allowClear: true,
      size: 'small',
    },
    editor: ComponentPropertyEditor.component,
  },
  {
    name: 'condition',
    description: '条件表达式',
    component: 'condition-picker',
    slot: {},
    attrs: {
      style: { width: '100%' },
      allowClear: false,
      size: 'small',
    },
    editor: ComponentPropertyEditor.condition,
  },
  {
    name: 'variable',
    description: '数据源',
    component: 'variable-picker',
    slot: {},
    attrs: {
      style: { width: '100%' },
      allowClear: false,
      size: 'small',
    },
    editor: ComponentPropertyEditor.variable,
  },
];

export function initPropertyEditors(): Record<string, PropertyEditor> {
  const _propertyEditors = propertyEditors.map(i => ({ [i.editor]: i }));
  return Object.assign({}, ..._propertyEditors);
}
